import clsx from "clsx";
import { PropsWithChildren, ReactNode } from "react";
import Center from "../../core/Center/Center";
import Text, { TextTag } from "../../core/Text/Text";
import styles from "./Intro.module.scss";

export enum IntroColor {
  Beige1 = "beige1",
  Beige2 = "beige2",
  Beige3 = "beige3",
}

type IntroProps = PropsWithChildren<{
  headline: string;
  text: string;
  color?: IntroColor;
  button?: ReactNode;
  image?: ReactNode;
}>;

const Intro = ({
  headline,
  text,
  color = IntroColor.Beige3,
  button,
  image,
  children,
}: IntroProps) => {
  return (
    <Center className={clsx(styles.intro, styles[color])}>
      <div className={styles.inner}>
        <Text as={TextTag.H1} text={headline} />
        <Text text={text} size={2} />
        {button && <div className={styles.button}>{button}</div>}
        {image && <div className={styles.image}>{image}</div>}
        {children}
      </div>
    </Center>
  );
};

export default Intro;
